import React, { useState } from 'react';
import Campo from './Campo';

const CampiMenu = ({ onCampiChange, initialCampi = [] }) => {
  const [campi, setCampi] = useState(
    initialCampi.length > 0
      ? initialCampi.map(c => ({
          nome: c.nome || c.categoria || '',
          descrizione: c.descrizione || (Array.isArray(c.options) ? c.options.join(', ') : '')
        }))
      : [{ nome: '', descrizione: '' }]
  );

  const aggiungiCampo = () => {
    const nuoviCampi = [...campi, { nome: '', descrizione: '' }];
    setCampi(nuoviCampi);
    onCampiChange(nuoviCampi);
  };

  const handleRemoveCampo = (index) => {
    const nuoviCampi = [...campi];
    nuoviCampi.splice(index, 1);
    setCampi(nuoviCampi);
    onCampiChange(nuoviCampi);
  };

  const handleCampoChange = (index, e) => {
    const { name, value } = e.target;
    const nuoviCampi = [...campi];
    nuoviCampi[index][name] = value;
    setCampi(nuoviCampi);
    onCampiChange(nuoviCampi);
  };

  return (
    <div>
      {campi.map((campo, index) => (
        <Campo
          key={index}
          nome={campo.nome}
          descrizione={campo.descrizione}
          onChange={(e) => handleCampoChange(index, e)}
          onRemove={() => handleRemoveCampo(index)}
        />
      ))}
      <button type="button" onClick={aggiungiCampo}>Aggiungi portate</button>
    </div>
  );
};

export default CampiMenu;
